import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '../components/Auth';
import { useStudioUnauthenticatedContext } from '../context/StudioContext';
import { AuthPage } from '../page-templates/AuthPage';

export const LoginPage: React.FC = () => {
  const { currentUser } = useStudioUnauthenticatedContext();
  const navigate = useNavigate();

  // Redirect to dashboard if already logged in
  useEffect(() => {
    if (currentUser) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  const handleSignUpClick = () => {
    // Navigate to signup page without name parameter to show "Welcome to Clips Studio"
    navigate('/signup');
  };

  return (
    <AuthPage>
      <LoginForm onSignUpClick={handleSignUpClick} />
    </AuthPage>
  );
};
